import { getFramework, type IFramework } from '@/framework';
import { getFusionImageState, watchFusionImageState, type IStore } from './state';

export class EdgelessFusionImagePlugin {
    /** 编辑器实例 */
    private framework: IFramework;
    private store: IStore;
    private panel: React.ReactNode = null;

    constructor(identity: string) {
        this.framework = getFramework(identity);
        this.store = getFusionImageState(this.framework.identity);

        watchFusionImageState(identity, (store) => {
            this.store = store;
        });
    }

    setPanel(panel: React.ReactNode) {
        this.panel = panel;
    }

    getPanel() {
        return this.panel;
    }

    getState() {
        return this.store;
    }

    watchState(callback: (state: IStore) => void) {
        return watchFusionImageState(this.framework.identity, callback);
    }

    /** 打开扩展图片 */
    open(layerIds: string[]) {
        const originLayers = layerIds.map((layerId) => this.framework.service.flatLayer.getLayer(layerId));

        if (originLayers.some((layer) => !layer)) return;

        this.store.init(originLayers);
    }

    /** 关闭扩展图片 */
    close() {
        this.store.destroy();
    }

    /** 重置扩展图片的图层为原图 */
    reset() {
        const originLayers = this.store.originLayers;

        if (!originLayers) {
            return;
        }
    }

    async getApplyData() {
        const { store } = this;

        const { originLayers } = store;

        if (!originLayers) return;

        return {
            originLayers,
        };
    }
}
